import axios from "axios";
import { logger } from "./logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: required for the httpOnly session cookie set by
// /api/audit/start to be sent on subsequent requests (resume, answer, submit).
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Fire-and-forget event tracking. Logs on failure, never throws upward.
// Platform tag is always "web" — the mobile client sends "mobile" from its own trackEvent.
export const trackEvent = async (event_type, page, metadata = {}, session_id = null) => {
  try {
    await api.post("/events/track", {
      event_type, page,
      metadata: { ...metadata, platform: "web" },
      session_id,
    });
  } catch (err) {
    // Analytics is non-blocking by design, but the failure is still recorded
    // to the browser console for ops visibility.
    logger.error("trackEvent_failed", { event_type, page, err: err?.message || String(err) });
  }
};
